import React, { Component } from 'react'
import { Field, Button } from 'components/elements'
import {
  BRAND_FILTER_SHORT_NAME,
  brandDefault,
} from '../brand/searchBrandConfig'
import {
  PRICE_FILTER_SHORT_NAME,
  priceDefault,
} from '../price/priceFilterConfig'
import {
  STYLE_FILTER_SHORT_NAME,
  styleDefault,
} from '../style/styleFilterConfig'
import {
  MAX_DISTANCE_FILTER_SHORT_NAME,
  MIN_DISTANCE_FILTER_SHORT_NAME,
  maxDistanceDefault,
  minDistanceDefault,
  distanceOptions,
} from '../moreFiltersContainer/distanceFilterConfig'
import {
  sortByDefault,
  sortByOptions,
  SORTBY_FILTER_SHORT_NAME
} from '../sortby/sortByFilterConfig'
import {
  YEAR_FILTER_SHORT_NAME,
  yearDefault,
} from '../moreFiltersContainer/yearsFilterConfig'
import {
  PAGE_FILTER_SHORT_NAME,
  pageDefault,
} from '../pagination/paginationFilterConfig'
import { 
  seatDefault, 
  SEAT_FILTER_SHORT_NAME 
} from '../moreFiltersContainer/seatFilterConfig'
import { 
  engineDefault, 
  ENGINE_FILTER_SHORT_NAME 
} from '../moreFiltersContainer/engineFilterConfig'
import {
  START_DATE_SHORT_NAME,
  END_DATE_SHORT_NAME,
  startDateDefault,
  endDateDefault,
} from '../dates/datesFilterConfig'
import {
  IS_BIKE_FOR_SALE_FILTER_SHORT_NAME,
  isBikeForSaleDefault,
} from '../moreFiltersContainer/isBikeForSaleFilterConfig'
import {
  INSTANT_BOOKING_SHORT_NAME,
  bookingFilterDefault,
} from '../instantBooking/instantBookingConfig'
import MobileDatesSelector from '../../../elements/dateSelector/mobileDatesSelector'
import isBeforeDay from '../../../elements/dateSelector/airbnbUtils/isBeforeDay'
import './mobileSearchFilters.sass'
import { withRouter } from 'react-router-dom'
import {
  removeDefaults,
  buildTheQueryString,
} from '../../filters/filterUtil.js'
import { searchFilterDefaults } from '../../filters/filters'
import moment from 'moment'
import { bikeCategories, bikeBrands } from '../../../../constants'
import PriceInput from '../../filters/filterInputs/priceInput.js'
import YearInput from '../../filters/filterInputs/yearInput.js'
import EngineInput from '../filterInputs/engineInput'
import SeatInput from '../filterInputs/seatInput'
import ChipGroup from '../../filters/filterInputs/chipGroup.js'
import {
  trackMobileFiltersOpen,
  trackMobileFiltersClosed,
  trackMobileFiltersCleared,
  trackMobileFiltersApplied,
} from '../../../elements/tracking/searchTracking.js'
import DateWarningTicker from 'components/elements/dateWarningTicker'
import {
  newlyListedDefault,
  NEWLY_LISTED_FILTER_SHORT_NAME
} from '../moreFiltersContainer/newlyListedConfig'
import {
  TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME,
  twentyPointInspectedDefault
} from '../moreFiltersContainer/twentyPointInspected'

let classNames = require('classnames')

class MobileSearchFilters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filterValues: this.props.filterValues,
      showMobileFilters: false,
      mobileFiltersPrevState: this.props.filterValues,
      focusedInput: 'startDate',
      cleared: false,
    }
  }

  componentDidMount() {
    console.log(JSON.stringify(this.props.filterValues))
  }

  toggleMap = (value) => {
    this.props.onToggleMap(value)
  }

  toggleMobileFilters = (toggleState) => {
    if (toggleState) {
      document.body.classList.add('mobile-filters-open')
      localStorage.setItem(
        'prevFiltersState',
        JSON.stringify(this.state.filterValues)
      )
      const currentFilterState = { ...this.state.filterValues }
      this.setState({
        mobileFiltersPrevState: currentFilterState,
        showMobileFilters: toggleState,
      })
      trackMobileFiltersOpen()
    } else {
      document.body.classList.remove('mobile-filters-open')
      if (this.state.cleared) {
        this.setState({
          cleared: false,
          showMobileFilters: toggleState,
        })
        trackMobileFiltersCleared()
        this.handleMobileApply()
      } else {
        const pastFilterState = JSON.parse(
          localStorage.getItem('prevFiltersState')
        )
        this.setState({
          filterValues: pastFilterState,
          showMobileFilters: toggleState,
          cleared: false,
        })
        trackMobileFiltersClosed()
        localStorage.removeItem('prevFiltersState')
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.filterValues !== prevProps.filterValues) {
      if (this.props.filterValues !== this.state.filterValues) {
        this.setState({ filterValues: this.props.filterValues })
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('mobile-filters-open')
  }

  updateFilterValue = (filterName, filterValue) => {
    this.setState((state) => {
      state.filterValues[filterName] = filterValue
      return state
    })
  }

  handleMobileApply = () => {
    document.body.classList.remove('mobile-filters-open')
    let cleanValues = JSON.parse(JSON.stringify(this.state.filterValues))
    cleanValues = removeDefaults(cleanValues)

    if (cleanValues.startDate) {
      cleanValues['startDate'] = moment(cleanValues['startDate']).format(
        'YYYY-MM-DD'
      )
    }
    if (cleanValues.endDate) {
      cleanValues['endDate'] = moment(cleanValues['endDate']).format(
        'YYYY-MM-DD'
      )
    }

    if (cleanValues.hasOwnProperty('page')) {
      delete cleanValues.page
    }

    if (cleanValues.hasOwnProperty('page_count')) {
      delete cleanValues.page_count
    }

    let newQueryString = buildTheQueryString(cleanValues)

    this.props.history.push('?' + newQueryString)
    this.setState({
      filterValues: cleanValues,
      showMobileFilters: false,
    })

    trackMobileFiltersApplied(cleanValues)
    this.props.onApply(cleanValues)
  }

  hideFilters = () => {
    this.setState({
      showMobileFilters: false,
    })
  }

  clearAll = () => {
    let filterValues = JSON.parse(JSON.stringify(this.state.filterValues))

    filterValues[STYLE_FILTER_SHORT_NAME] = [...styleDefault]
    filterValues[INSTANT_BOOKING_SHORT_NAME] = bookingFilterDefault
    filterValues[PRICE_FILTER_SHORT_NAME] = priceDefault
    filterValues[SORTBY_FILTER_SHORT_NAME] = sortByDefault
    filterValues[SEAT_FILTER_SHORT_NAME] = seatDefault
    filterValues[ENGINE_FILTER_SHORT_NAME] = engineDefault
    filterValues[BRAND_FILTER_SHORT_NAME] = [...brandDefault]
    filterValues[MAX_DISTANCE_FILTER_SHORT_NAME] = maxDistanceDefault
    filterValues[MIN_DISTANCE_FILTER_SHORT_NAME] = minDistanceDefault
    filterValues[YEAR_FILTER_SHORT_NAME] = yearDefault
    filterValues[START_DATE_SHORT_NAME] = startDateDefault
    filterValues[END_DATE_SHORT_NAME] = endDateDefault
    filterValues[PAGE_FILTER_SHORT_NAME] = pageDefault
    filterValues[NEWLY_LISTED_FILTER_SHORT_NAME] = newlyListedDefault
    filterValues[TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME] = twentyPointInspectedDefault
    filterValues[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME] = isBikeForSaleDefault

    this.setState({
      filterValues,
      cleared: true,
    })
  }

  onFocusChange = (focusedInput) => {
    this.setState({
      // Force the focusedInput to always be truthy so that dates are always selectable
      focusedInput: !focusedInput ? 'startDate' : focusedInput,
    })
  }

  onDatesChange = (startDate, endDate) => {
    this.updateFilterValue(START_DATE_SHORT_NAME, startDate)
    this.updateFilterValue(END_DATE_SHORT_NAME, endDate)
  }

  render() {
    const { mapVisible, showDateWarning } = this.props
    const { showMobileFilters, filterValues } = this.state
    let mobileFiltersWrap = classNames(
      'mobile-filters-wrap animate__animated animate__faster animate__fadeIn',
      this.props.className,
      {
        'mobile-filters-open': showMobileFilters,
        'mobile-filters-closed': !showMobileFilters,
      }
    )

    if (filterValues) {
      return (
        <React.Fragment>
          {showDateWarning && this.props.isMobile && <DateWarningTicker />}
          <div className="mobile-filter-buttons">
            <div className="mobile-filter-buttons-bg has-box-shadow has-border">
              {!mapVisible && (
                <button
                  className="button is-white is-medium"
                  onClick={() => this.toggleMap(true)}
                >
                  <span className="icon">
                    <i className="fas fa-map"></i>
                  </span>
                  <span>Map</span>
                </button>
              )}
              {mapVisible && (
                <button
                  className="button is-white is-medium"
                  onClick={() => this.toggleMap(false)}
                >
                  <span className="icon">
                    <i className="fas fa-th"></i>
                  </span>
                  <span>Listings</span>
                </button>
              )}
              <button
                className={`button is-white is-medium ${showDateWarning ? 'danger-border' : ''
                  }`}
                onClick={() => this.toggleMobileFilters(true)}
              >
                {' '}
                <span className="icon">
                  <i className="fas fa-sliders-h"></i>
                </span>
                <span>Filters</span>
              </button>
            </div>
          </div>
          {showMobileFilters && (
            <div className={mobileFiltersWrap}>
              <div className="columns is-vcentered is-mobile m-0">
                <div className="column is-6">
                  <button
                    className="button is-white"
                    onClick={() => this.clearAll()}
                  >
                    Clear All
                  </button>
                </div>
                <div className="column is-6 has-text-right">
                  <button
                    className="delete is-medium"
                    onClick={() => this.toggleMobileFilters(false)}
                  />
                </div>
              </div>
              <div className="mobile-filters-content">
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Dates
                  </h2>
                  <MobileDatesSelector
                    additionalDateProps={{
                      isOutsideRange: (day) => isBeforeDay(day, moment()),
                    }}
                    onDatesChange={this.onDatesChange}
                    onFocusChange={this.onFocusChange}
                    hideFilters={this.hideFilters}
                    focusedInput={this.state.focusedInput}
                    startDate={filterValues[START_DATE_SHORT_NAME]}
                    endDate={filterValues[END_DATE_SHORT_NAME]}
                    selectorType="button"
                    hasDangerBorder={showDateWarning}
                  />
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Sort by
                  </h2>
                  <Field
                    type="select"
                    id="sortby"
                    name="sortby"
                    showErrors={false}
                    fullwidth
                    value={
                      filterValues[SORTBY_FILTER_SHORT_NAME]
                        ? filterValues[SORTBY_FILTER_SHORT_NAME]
                        : sortByDefault
                    }
                    onChange={({ value }) => {
                     this.updateFilterValue(
                      SORTBY_FILTER_SHORT_NAME,
                      sortByDefault
                    )
                    this.updateFilterValue(
                      SORTBY_FILTER_SHORT_NAME,
                      value
                    )
                    }}
                    options={sortByOptions}
                  />
                </div>
                <div className="mobile-filter-block">
                  <Field
                    showErrors={false}
                    label={'Book Instantly'}
                    labelclassname={'mr-0'}
                    checked={filterValues[INSTANT_BOOKING_SHORT_NAME]}
                    type="checkbox"
                    id="instantBooking"
                    name="instantBooking"
                    checkedReturn={'boolean'}
                    onChange={({ checked }) =>
                      this.updateFilterValue(
                        INSTANT_BOOKING_SHORT_NAME,
                        checked
                      )
                    }
                  />
                </div>
                <div className="mobile-filter-block">
                  <Field
                    showErrors={false}
                    label={'20-Point Inspected'}
                    labelclassname={'mr-0'}
                    checked={filterValues[TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME]}
                    type="checkbox"
                    id="twentyPointInspected"
                    name="twentyPointInspected"
                    checkedReturn={'boolean'}
                    onChange={({ checked }) =>
                      this.updateFilterValue(
                        TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME,
                        checked
                      )
                    }
                  />
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Distance
                  </h2>
                  <Field
                    type="select"
                    id="distance"
                    name="distance"
                    showErrors={false}
                    fullwidth
                    value={
                      filterValues[MAX_DISTANCE_FILTER_SHORT_NAME]
                        ? filterValues[MAX_DISTANCE_FILTER_SHORT_NAME]
                        : maxDistanceDefault
                    } //i hate this also...
                    onChange={({ value }) => {
                      this.updateFilterValue(
                        MIN_DISTANCE_FILTER_SHORT_NAME,
                        minDistanceDefault
                      )
                      this.updateFilterValue(
                        MAX_DISTANCE_FILTER_SHORT_NAME,
                        value
                      )
                    }}
                    options={distanceOptions}
                  />
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Price
                  </h2>
                  <PriceInput
                    currentRange={filterValues[PRICE_FILTER_SHORT_NAME]}
                    onChange={(value) =>
                      this.updateFilterValue(PRICE_FILTER_SHORT_NAME, value)
                    }
                  />
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Style
                  </h2>
                  <div className="mt-5">
                    <ChipGroup
                      chipType='bikeCategories'
                      chipData={bikeCategories}
                      labelKey={'catLabel'}
                      valueKey={'catName'}
                      iconKey={'catIconUrl'}
                      onChange={(value) =>
                        this.updateFilterValue(STYLE_FILTER_SHORT_NAME, value)
                      }
                      selectedChips={filterValues[STYLE_FILTER_SHORT_NAME]}
                    />
                  </div>
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Brand
                  </h2>
                  <div className="mt-5">
                    <ChipGroup
                      chipData={bikeBrands}
                      labelKey={'value'}
                      valueKey={'value'}
                      iconKey={'catIconUrl'}
                      onChange={(value) =>
                        this.updateFilterValue(BRAND_FILTER_SHORT_NAME, value)
                      }
                      selectedChips={filterValues[BRAND_FILTER_SHORT_NAME]}
                    />
                  </div>
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Seat Height
                  </h2>
                  <SeatInput
                    currentRange={filterValues[SEAT_FILTER_SHORT_NAME]}
                    onChange={(value) => {
                      this.updateFilterValue(SEAT_FILTER_SHORT_NAME, value)
                    }}
                  />
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Engine Size
                  </h2>
                  <EngineInput
                    currentRange={filterValues[ENGINE_FILTER_SHORT_NAME]}
                    onChange={(value) => {
                      this.updateFilterValue(ENGINE_FILTER_SHORT_NAME, value)
                    }}
                  />
                </div>
                <div className="mobile-filter-block">
                  <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                    Years
                  </h2>
                  <YearInput
                    currentRange={filterValues[YEAR_FILTER_SHORT_NAME]}
                    onChange={(value) =>
                      this.updateFilterValue(YEAR_FILTER_SHORT_NAME, value)
                    }
                  />
                </div>
                <div className="mobile-filter-block">
                  <Field
                    showErrors={false}
                    label={'Newly Listed'}
                    labelclassname={'mr-0'}
                    checked={filterValues[NEWLY_LISTED_FILTER_SHORT_NAME]}
                    type="checkbox"
                    id="isNewlyListed"
                    name="isNewlyListed"
                    checkedReturn={'boolean'}
                    onChange={({ checked }) => {
                        this.updateFilterValue(
                          NEWLY_LISTED_FILTER_SHORT_NAME,
                          checked
                        )
                      }
                    }
                  />
                </div>
                <div className="mobile-filter-block">
                  <Field
                    showErrors={false}
                    label={'Only show motorcycles for sale'}
                    labelclassname={'mr-0'}
                    checked={filterValues[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME]}
                    type="checkbox"
                    id="isBikeForSale"
                    name="isBikeForSale"
                    checkedReturn={'boolean'}
                    onChange={({ checked }) =>
                      this.updateFilterValue(
                        IS_BIKE_FOR_SALE_FILTER_SHORT_NAME,
                        checked
                      )
                    }
                  />
                </div>
              </div>
              <div className="mobile-filters-footer">
                <Button
                  size="medium"
                  fullwidth
                  className="has-text-weight-bold"
                  color="primary"
                  onClick={() => this.handleMobileApply()}
                >
                  APPLY FILTERS
                </Button>
              </div>
            </div>
          )}
        </React.Fragment>
      )
    }
    if (!filterValues) {
      return <React.Fragment />
    }
  }
}

export default withRouter(MobileSearchFilters)

MobileSearchFilters.defaultProps = {
  mapVisible: false,
  isMobile: false,
  onToggleMap: function () { },
  onApply: function () { },
  filterValues: searchFilterDefaults,
  onClearAll: function () { },
  showDateWarning: false,
}
